import store from "@/state/store";

export default [
  {
    path: "/login",
    name: "login",
    component: () => import("../views/account/login.vue"),
    meta: {
      title: "Login",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in (check actual token, not stale Vuex state)
        const token = localStorage.getItem('auth_token');
        const user = sessionStorage.getItem('authUser');
        if (token && user) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/register",
    name: "Register",
    component: () => import("../views/account/register.vue"),
    meta: {
      title: "Register",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/forgot-password",
    name: "Forgot password",
    component: () => import("../views/account/forgot-password.vue"),
    meta: {
      title: "Forgot Password",
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters["auth/loggedIn"]) {
          // Redirect to the home page instead
          next({ name: "default" });
        } else {
          // Continue to the login page
          next();
        }
      },
    },
  },
  {
    path: "/reset-password",
    name: "Reset password",
    component: () => import("../views/account/reset-password.vue"),
    meta: {
      title: "Reset Password",
      beforeResolve(routeTo, routeFrom, next) {
        if (store.getters["auth/loggedIn"]) {
          next({ name: "default" });
        } else {
          next();
        }
      },
    },
  },
  {
    path: "/download-apk",
    name: "apk-download",
    component: () => import("../views/apk-download/index.vue"),
    meta: {
      title: "Download APK",
    },
  },
  {
    path: "/lock-screen",
    name: "lock-screen",
    component: () => import("../views/auth/lockscreen/basic.vue"),
    meta: {
      title: "Lock Screen",
      authRequired: true,
    },
  },
  {
    path: "/",
    name: "default",
    meta: {
      title: "Dashboard",
      authRequired: true,
      permission: "view:dashboard",
    },
    component: () => import("../views/dashboard/dashboard1/index.vue"),
  },
  {
    path: "/dashboard/tv",
    name: "dashboard-tv",
    meta: {
      title: "TV Display",
      authRequired: true,
    },
    component: () => import("../views/dashboard/dashboard1/tv-display.vue"),
  },
  {
    path: "/queuing",
    name: "dashboard-queue-sync",
    meta: {
      title: "Queue Sync",
      authRequired: true,
      permission: "view:queuing",
    },
    component: () => import("../views/dashboard/dashboard2/index.vue"),
  },
  {
    path: "/job-queue",
    name: "dashboard-job-queue",
    meta: {
      title: "Job Queue",
      authRequired: true,
      permission: "view:job-queue",
    },
    component: () => import("../views/dashboard/jobQueue/index.vue"),
  },
  // Trucker Acceptance
  {
    path: "/trucker-acceptance",
    name: "trucker-acceptance",
    meta: { title: "Trucker Acceptance", authRequired: true, permission: "view:trucker-acceptance" },
    component: () => import("../views/trucker-acceptance/index.vue"),
  },
  // Booking Planning (Race-to-Accept)
  {
    path: "/booking-planning",
    name: "booking-planning",
    meta: { title: "Booking Planning", authRequired: true, permission: "view:booking-planning" },
    component: () => import("../views/booking-planning/index.vue"),
  },
  // Automatic Rotation — the alternative to Booking Planning above, selected
  // per-push via dispatch_mode. No race here: an assignment already belongs
  // to the contractor, they just Complete or Reject it.
  {
    path: "/dispatch-planning-queue",
    name: "dispatch-planning-queue",
    meta: { title: "My Planning Queue", authRequired: true, permission: "view:dispatch-planning-queue" },
    component: () => import("../views/dispatch-planning-queue/index.vue"),
  },
  // Document Validation — review POD/status attachments per TBR, categorize
  // + rename, and email the organized set out for validation.
  {
    path: "/document-validation",
    name: "document-validation",
    meta: { title: "Document Validation", authRequired: true, permission: "view:document-validation" },
    component: () => import("../views/document_validation/index.vue"),
  },
  // Dispatch by Contractor — the §7B reverse pivot (dispatcher-facing):
  // what does contractor X have, live + historical. Rotation-only for now.
  {
    path: "/dispatch-by-contractor",
    name: "dispatch-by-contractor",
    meta: { title: "Dispatch by Contractor", authRequired: true, permission: "view:dispatch-by-contractor" },
    component: () => import("../views/dispatch-by-contractor/index.vue"),
  },
  // System Settings
  {
    path: "/settings/system",
    name: "settings-system",
    meta: { title: "System Settings", authRequired: true, permission: "view:settings_system" },
    component: () => import("../views/settings/system/index.vue"),
  },
  // Settings - User Management
  {
    path: "/settings/users",
    name: "settings-users",
    meta: { title: "Users", authRequired: true, permission: "view:users" },
    component: () => import("../views/settings/users/index.vue"),
  },
  // Settings - Location Codes
  {
    path: "/maintenance/location-codes",
    name: "maintenance-location-codes",
    meta: { title: "Location Codes", authRequired: true, permission: "view:location-codes" },
    component: () => import("../views/maintenance/location-codes/index.vue"),
  },
  // Settings - Trucker Rates
  {
    path: "/maintenance/trucker-rates",
    name: "maintenance-trucker-rates",
    meta: { title: "Trucker Rates", authRequired: true, permission: "view:trucker-rates" },
    component: () => import("../views/maintenance/trucker-rates/index.vue"),
  },
  // Maintenance - Satellites
  {
    path: "/maintenance/satellites",
    name: "maintenance-satellites",
    meta: { title: "Satellites", authRequired: true, permission: "view:satellites" },
    component: () => import("../views/maintenance/satellites/index.vue"),
  },
  // Maintenance - Area Codes
  {
    path: "/maintenance/area-codes",
    name: "maintenance-area-codes",
    meta: { title: "Area Codes", authRequired: true, permission: "view:area-codes" },
    component: () => import("../views/maintenance/area-codes/index.vue"),
  },
  // Maintenance - Trip Types
  {
    path: "/maintenance/trip-types",
    name: "maintenance-trip-types",
    meta: { title: "Trip Types", authRequired: true, permission: "view:trip-types" },
    component: () => import("../views/maintenance/trip-types/index.vue"),
  },
  // Maintenance - Document Types
  {
    path: "/maintenance/document-types",
    name: "maintenance-document-types",
    meta: { title: "Document Types", authRequired: true, permission: "view:document-types" },
    component: () => import("../views/maintenance/document-types/index.vue"),
  },
  // Maintenance - Email List
  {
    path: "/maintenance/email-list",
    name: "maintenance-email-list",
    meta: { title: "Email List", authRequired: true, permission: "view:email-list" },
    component: () => import("../views/maintenance/email-list/index.vue"),
  },
  // Maintenance - Barangays
  {
    path: "/maintenance/barangays",
    name: "maintenance-barangays",
    meta: { title: "Barangays", authRequired: true, permission: "view:barangays" },
    component: () => import("../views/maintenance/barangays/index.vue"),
  },
  // Maintenance - Vehicle Checklist Categories
  {
    path: "/maintenance/vehicle-checklist-categories",
    name: "maintenance-vehicle-checklist-categories",
    meta: { title: "Vehicle Checklist Categories", authRequired: true, permission: "view:vehicle-checklist-categories" },
    component: () => import("../views/maintenance/vehicle-checklist-categories/index.vue"),
  },
  // Vehicle Checklists
  {
    path: "/vehicle-checklists",
    name: "vehicle-checklists",
    meta: { title: "Vehicle Checklists", authRequired: true, permission: "view:vehicle-checklist" },
    component: () => import("../views/vehicle-checklists/index.vue"),
  },
  {
    path: "/vehicle-checklists/create",
    name: "vehicle-checklists-create",
    meta: { title: "New Vehicle Checklist", authRequired: true },
    component: () => import("../views/vehicle-checklists/form.vue"),
  },
  // {
  //   path: "/vehicle-checklists/:id",
  //   name: "vehicle-checklists-view",
  //   meta: { title: "View Vehicle Checklist", authRequired: true },
  //   component: () => import("../views/vehicle-checklists/form.vue"),
  // },
  {
    path: "/vehicle-checklists/:id/edit",
    name: "vehicle-checklists-edit",
    meta: { title: "Edit Vehicle Checklist", authRequired: true },
    component: () => import("../views/vehicle-checklists/form.vue"),
  },
  {
    path: "/vehicle-checklists/:id",
    name: "vehicle-checklists-print",
    meta: { title: "Print Vehicle Checklist", authRequired: true },
    component: () => import("../views/vehicle-checklists/view.vue"),
  },
  // Maintenance - Cities
  {
    path: "/maintenance/cities",
    name: "maintenance-cities",
    meta: { title: "Cities", authRequired: true, permission: "view:cities" },
    component: () => import("../views/maintenance/cities/index.vue"),
  },
  // Maintenance - Countries
  {
    path: "/maintenance/countries",
    name: "maintenance-countries",
    meta: { title: "Countries", authRequired: true, permission: "view:countries" },
    component: () => import("../views/maintenance/countries/index.vue"),
  },
  // Maintenance - Unavailability Reasons
  {
    path: "/maintenance/unavailability-reasons",
    name: "maintenance-unavailability-reasons",
    meta: { title: "Unavailability Reasons", authRequired: true, permission: "view:unavailability-reasons" },
    component: () => import("../views/maintenance/unavailability-reasons/index.vue"),
  },
  // Maintenance - Provinces
  {
    path: "/maintenance/provinces",
    name: "maintenance-provinces",
    meta: { title: "Provinces", authRequired: true, permission: "view:provinces" },
    component: () => import("../views/maintenance/provinces/index.vue"),
  },
  // Maintenance - Status Automations
  {
    path: "/maintenance/status-automations",
    name: "maintenance-status-automations",
    meta: { title: "Status Automations", authRequired: true, permission: "view:status-automations" },
    component: () => import("../views/maintenance/status-automations/index.vue"),
  },
  // Maintenance - Charge List
  {
    path: "/maintenance/charge-list",
    name: "maintenance-charge-list",
    meta: { title: "Charge List", authRequired: true, permission: "view:charge-list" },
    component: () => import("../views/maintenance/charge-list/index.vue"),
  },
  // Maintenance - Charges
  {
    path: "/maintenance/charges",
    name: "maintenance-charges",
    meta: { title: "Charges", authRequired: true },
    component: () => import("../views/charges/index.vue"),
  },
  // Settings - User Access Management
  {
    path: "/settings/user-access",
    name: "settings-user-access",
    meta: { title: "User Access Management", authRequired: true, permission: "view:user-access" },
    component: () => import("../views/settings/user-access/index.vue"),
  },
  // Settings - Role Access Management
  {
    path: "/settings/role-access",
    name: "settings-role-access",
    meta: { title: "Role Access Management", authRequired: true, permission: "view:role-access" },
    component: () => import("../views/settings/role-access/index.vue"),
  },
  // Settings - Dispatch Groups
  {
    path: "/settings/dispatch-groups",
    name: "settings-dispatch-groups",
    meta: { title: "Dispatch Groups", authRequired: true, permission: "view:dispatch-groups" },
    component: () => import("../views/settings/dispatch-groups/index.vue"),
  },
  // Main - Expenses
  {
    path: "/expenses",
    name: "main-expenses",
    meta: { title: "Expenses", authRequired: true, permission: "view:expense" },
    component: () => import("../views/main/expenses/index.vue"),
  },
  // Reports - Summary Report
  {
    path: "/reports/summary",
    name: "reports-summary",
    meta: { title: "Summary Report", authRequired: true, permission: "view:tbrsummary" },
    component: () => import("../views/reports/summary/index.vue"),
  },
  // Reports - TRAMS Reconciliation
  {
    path: "/reports/trams-reconciliation",
    name: "reports-trams-reconciliation",
    meta: { title: "TRAMS Reconciliation Report", authRequired: true, permission: "view:reports.trams-reconciliation" },
    component: () => import("../views/reports/trams-reconciliation/index.vue"),
  },
  // Reports - Cancellation, Un-push & Unserve (consolidated trip cancellations + booking un-pushes/unserves)
  {
    path: "/reports/cancellation-unpush",
    name: "reports-cancellation-unpush",
    meta: { title: "Cancellation, Un-push & Unserve Report", authRequired: true, permission: "view:reports.cancellation-unpush" },
    component: () => import("../views/reports/cancellation-unpush/index.vue"),
  },
  // Reports - Driver/Helper Username Audit (fixes TRAMS-synced trip tickets
  // that carry a plain crew name where a personnel username belongs)
  {
    path: "/reports/crew-username-audit",
    name: "reports-crew-username-audit",
    meta: { title: "Driver/Helper Username Audit", authRequired: true, permission: "view:reports.crew-username-audit" },
    component: () => import("../views/reports/crew-username-audit/index.vue"),
  },
  // Reports - Planning Audit (mobile open/cancel/complete engagement per TBR)
  {
    path: "/reports/planning-audit",
    name: "reports-planning-audit",
    meta: { title: "Planning Audit Report", authRequired: true, permission: "view:reports.planning-audit" },
    component: () => import("../views/reports/planning-audit/index.vue"),
  },
  // Reports - Dispatch Rotation Audit (auto-rotation counterpart to Planning Audit above)
  {
    path: "/reports/dispatch-rotation-audit",
    name: "reports-dispatch-rotation-audit",
    meta: { title: "Dispatch Rotation Audit Report", authRequired: true, permission: "view:reports.dispatch-rotation-audit" },
    component: () => import("../views/reports/dispatch-rotation-audit/index.vue"),
  },
  // Reports - On-Time Delivery
  {
    path: "/reports/otd",
    name: "reports-otd",
    meta: { title: "On-Time Delivery Report", authRequired: true, permission: "view:report.otd" },
    component: () => import("../views/reports/otd/index.vue"),
  },
  // Reports - Delivery Time
  {
    path: "/reports/delivery-time",
    name: "reports-delivery-time",
    meta: { title: "Delivery Time Analysis", authRequired: true, permission: "view:reports.delivery-time" },
    component: () => import("../views/reports/delivery-time/index.vue"),
  },
  // Reports - Driver Scorecard
  {
    path: "/reports/driver-scorecard",
    name: "reports-driver-scorecard",
    meta: { title: "Driver Scorecard", authRequired: true, permission: "view:reports.driver-scorecard" },
    component: () => import("../views/reports/driver-scorecard/index.vue"),
  },
  // Reports - Contractor Performance
  {
    path: "/reports/contractor-performance",
    name: "reports-contractor-performance",
    meta: { title: "Contractor Performance", authRequired: true, permission: "view:reports.contractor-performance" },
    component: () => import("../views/reports/contractor-performance/index.vue"),
  },
  // Reports - Vehicle Utilization
  {
    path: "/reports/vehicle-utilization",
    name: "reports-vehicle-utilization",
    meta: { title: "Vehicle Utilization", authRequired: true, permission: "view:reports.vehicle-utilization" },
    component: () => import("../views/reports/vehicle-utilization/index.vue"),
  },
  // Reports - Cost Analysis
  {
    path: "/reports/cost-analysis",
    name: "reports-cost-analysis",
    meta: { title: "Cost Analysis", authRequired: true, permission: "view:reports.cost-analysis" },
    component: () => import("../views/reports/cost-analysis/index.vue"),
  },
  // Reports - Fuel Efficiency
  {
    path: "/reports/fuel-efficiency",
    name: "reports-fuel-efficiency",
    meta: { title: "Fuel Efficiency Report", authRequired: true, permission: "view:reports.fuel-efficiency" },
    component: () => import("../views/reports/fuel-efficiency/index.vue"),
  },
  // Reports - Data Usage
  {
    path: "/reports/data-usage",
    name: "reports-data-usage",
    meta: { title: "Data Usage Report", authRequired: true, permission: "view:reports.data-usage" },
    component: () => import("../views/reports/data-usage/index.vue"),
  },
  // Reports - Incident Analysis
  {
    path: "/reports/incident-analysis",
    name: "reports-incident-analysis",
    meta: { title: "Incident Analysis", authRequired: true, permission: "view:reports.incident-analysis" },
    component: () => import("../views/reports/incident-analysis/index.vue"),
  },
  // Reports - Capacity Planning
  {
    path: "/reports/capacity-planning",
    name: "reports-capacity-planning",
    meta: { title: "Capacity Planning", authRequired: true, permission: "view:reports.capacity-planning" },
    component: () => import("../views/reports/capacity-planning/index.vue"),
  },
  // Reports - Peak Analysis
  {
    path: "/reports/peak-analysis",
    name: "reports-peak-analysis",
    meta: { title: "Peak Analysis", authRequired: true, permission: "view:reports.peak-analysis" },
    component: () => import("../views/reports/peak-analysis/index.vue"),
  },
  // Reports - Truck Availability
  {
    path: "/reports/truck-availability",
    name: "reports-truck-availability",
    meta: { title: "Truck Availability Report", authRequired: true, permission: "view:reports-truck-availability" },
    component: () => import("../views/reports/truck-availability/index.vue"),
  },
  // Reports - Login Logs
  {
    path: "/reports/login-logs",
    name: "reports-login-logs",
    meta: { title: "Login Logs", authRequired: true, permission: "view:reports-login-logs" },
    component: () => import("../views/reports/login-logs/index.vue"),
  },
  // Dashboard - Analytics 3
  {
    path: "/analytics",
    name: "dashboard-tramsAnalytics",
    meta: { title: "Analytics Dashboard", authRequired: true, permission: "view:analytics" },
    component: () => import("../views/dashboard/tramsAnalytics/index.vue"),
  },
  {
    path: "/booking",
    name: "booking",
    meta: { title: "Booking", authRequired: true, permission: "view:booking" },
    component: () => import("../views/booking/index.vue"),
  },
  {
    path: "/booking/create",
    name: "booking-create",
    meta: { title: "New Booking", authRequired: true },
    component: () => import("../views/booking/form.vue"),
  },
  {
    path: "/booking/edit/:id",
    name: "booking-edit",
    meta: { title: "Edit Booking", authRequired: true },
    component: () => import("../views/booking/form.vue"),
  },
  {
    path: "/trip-ticket",
    name: "trip-ticket",
    meta: { title: "Trip Tickets", authRequired: true, permission: "view:triptickets" },
    component: () => import("../views/trip_ticket/index.vue"),
  },
  {
    path: "/trip-monitor",
    name: "trip-monitor",
    meta: { title: "Trip Monitor", authRequired: true, permission: "view:trip-monitor" },
    component: () => import("../views/trip_monitor/index.vue"),
  },
  {
    path: "/dispatch-preparation",
    name: "dispatch-preparation",
    meta: { title: "Dispatch Preparation", authRequired: true, permission: "view:dispatch-preparation" },
    component: () => import("../views/dispatch-preparation/index.vue"),
  },
  {
    path: "/reports/planning-monitor",
    name: "reports-planning-monitor",
    meta: { title: "Planning Monitor", authRequired: true, permission: "view:reports.planning-monitor" },
    component: () => import("../views/reports/planning-monitor/index.vue"),
  },
  {
    path: "/reports/planning-kpi",
    name: "reports-planning-kpi",
    meta: { title: "Planning KPI Dashboard", authRequired: true, permission: "view:reports.planning-kpi" },
    component: () => import("../views/reports/planning-kpi/index.vue"),
  },
  {
    path: "/liveAppGPS",
    name: "live-app-gps",
    meta: { title: "Live Vehicle Tracking", authRequired: true, permission: "view:liveappgps" },
    component: () => import("../views/live-gps/index.vue"),
  },
    {
    path: "/liveAppGPS2",
    name: "live-app-gps",
    meta: { title: "Live Vehicle Tracking", authRequired: true, permission: "view:liveappgps" },
    component: () => import("../views/live-gps/index-cartrack.vue"),
  },
  {
    path: "/trip-ticket/form",
    name: "trip-ticket-create",
    meta: { title: "New Trip Ticket", authRequired: true },
    component: () => import("../views/trip_ticket/form.vue"),
  },
  {
    path: "/trip-ticket/form/:id",
    name: "trip-ticket-edit",
    meta: { title: "Edit Trip Ticket", authRequired: true },
    component: () => import("../views/trip_ticket/form.vue"),
  },
  {
    path: "/customers",
    name: "customer",
    meta: { title: "Customers", authRequired: true, permission: "view:customer" },
    component: () => import("../views/customer/index.vue"),
  },
  // Trucker Document Upload (Public - no auth)
  {
    path: "/trucker-upload/:token",
    name: "trucker-upload",
    meta: { title: "Upload Documents" },
    component: () => import("../views/trucker-upload/index.vue"),
  },
  {
    path: "/trucker",
    name: "trucker",
    meta: { title: "Trucker Companies", authRequired: true, permission: "view:truckercompany" },
    component: () => import("../views/trucker/index.vue"),
  },
  {
    path: "/trucker-applicants",
    name: "trucker-applicants",
    meta: { title: "Trucker Applicants", authRequired: true, permission: "view:truckercompany" },
    component: () => import("../views/trucker-applicants/index.vue"),
  },
  {
    path: "/trucker/create",
    name: "trucker-create",
    meta: { title: "New Trucker Company", authRequired: true, permission: "view:truckercompany" },
    component: () => import("../views/trucker/form.vue"),
  },
  {
    path: "/trucker/:id/edit",
    name: "trucker-edit",
    meta: { title: "Edit Trucker Company", authRequired: true, permission: "view:truckercompany" },
    component: () => import("../views/trucker/form.vue"),
  },
  {
    path: "/vehicles",
    name: "vehicles",
    meta: { title: "Vehicles", authRequired: true, permission: "view:vehicles" },
    component: () => import("../views/vehicles/index.vue"),
  },
  // Vehicle Unavailability
  {
    path: "/vehicle-unavailability",
    name: "vehicle-unavailability",
    meta: { title: "Vehicle Unavailability", authRequired: true, permission: "view:vehicle-unavailability" },
    component: () => import("../views/vehicle-unavailability/index.vue"),
  },
  // Vehicle Availability Gate (lock-screen style — forces gated roles to resolve unassigned vehicles)
  {
    path: "/vehicle-availability-gate",
    name: "vehicle-availability-gate",
    meta: { title: "Resolve Vehicle Availability", authRequired: true, permission: "view:vehicle-availability-gate" },
    component: () => import("../views/vehicle-availability-gate/index.vue"),
  },
  // Availability Gate Settings (admins pick which roles trigger the gate)
  {
    path: "/settings/availability-gate",
    name: "settings-availability-gate",
    meta: { title: "Availability Gate", authRequired: true, permission: "view:settings-availability-gate" },
    component: () => import("../views/settings/availability-gate/index.vue"),
  },
  // App Permission Gate Settings (admins pick required device permissions + gated roles)
  {
    path: "/settings/app-permission-gate",
    name: "settings-app-permission-gate",
    meta: { title: "App Permission Gate", authRequired: true, permission: "view:settings-app-permission-gate" },
    component: () => import("../views/settings/app-permission-gate/index.vue"),
  },
  // Business Rules Settings (per-platform ticks for operational policies, e.g. POD)
  {
    path: "/settings/business-rules",
    name: "settings-business-rules",
    meta: { title: "Business Rules", authRequired: true, permission: "view:settings-business-rules" },
    component: () => import("../views/settings/business-rules/index.vue"),
  },
  // Email Senders (reusable sender identities applied to users)
  {
    path: "/settings/email-senders",
    name: "settings-email-senders",
    meta: { title: "Email Senders", authRequired: true, permission: "view:settings-email-senders" },
    component: () => import("../views/settings/email-senders/index.vue"),
  },
  // Reason Maintenance (DB-backed reason lists for un-push, trip cancellation, mobile flags)
  {
    path: "/settings/reason-maintenance",
    name: "settings-reason-maintenance",
    meta: { title: "Reason Maintenance", authRequired: true, permission: "view:settings-reason-maintenance" },
    component: () => import("../views/settings/reason-maintenance/index.vue"),
  },
  // Number Coding Scheme (per-province/day plate-ending restrictions + exemption reasons)
  {
    path: "/settings/coding-scheme",
    name: "settings-coding-scheme",
    meta: { title: "Number Coding Scheme", authRequired: true, permission: "view:settings-coding-scheme" },
    component: () => import("../views/settings/coding-scheme/index.vue"),
  },
  // Vehicle Maintenance
  {
    path: "/vehicle-maintenance",
    name: "vehicle-maintenance",
    meta: { title: "Vehicle Maintenance", authRequired: true, permission: "view:vehicle-maintenance" },
    component: () => import("../views/vehicle-maintenance/index.vue"),
  },
  // Fuel Logs
  {
    path: "/fuel-logs",
    name: "fuel-logs",
    meta: { title: "Fuel Logs", authRequired: true, permission: "view:fuel-logs" },
    component: () => import("../views/fuel-logs/index.vue"),
  },
  // Maintenance Templates
  {
    path: "/maintenance-templates",
    name: "maintenance-templates",
    meta: { title: "Maintenance Templates", authRequired: true, permission: "view:maintenance-templates" },
    component: () => import("../views/maintenance-templates/index.vue"),
  },
  {
    path: "/incidents",
    name: "incidents",
    meta: { title: "Incidents", authRequired: true, permission: "view:incidents" },
    component: () => import("../views/incident/index.vue"),
  },
  {
    path: "/vehicle-types",
    name: "fleet-types",
    meta: { title: "Vehicles Types", authRequired: true, permission: "view:vehicle-types" },
    component: () => import("../views/fleet-types/index.vue"),
  },
  {
    path: "/make-types",
    name: "make-types",
    meta: { title: "Make Types", authRequired: true, permission: "view:make-types" },
    component: () => import("../views/make-types/index.vue"),
  },
  {
    path: "/wheeler-types",
    name: "wheeler-types",
    meta: { title: "Wheeler Types", authRequired: true, permission: "view:wheeler-types" },
    component: () => import("../views/wheeler-types/index.vue"),
  },
  {
    path: "/trucker-personnels",
    name: "trucker-personnel",
    meta: { title: "Trucker Personnel", authRequired: true, permission: "view:trucker-personnels" },
    component: () => import("../views/trucker_personnel/index.vue"),
  },
  {
    path: "/settings/roles",
    name: "settings-roles",
    meta: { title: "Roles", authRequired: true, permission: "view:roles" },
    component: () => import("../views/settings/roles/index.vue"),
  },
  {
    path: "/settings/trucker-grouping",
    name: "settings-trucker-grouping",
    meta: { title: "Trucker Grouping", authRequired: true, permission: "view:trucker-grouping" },
    component: () => import("../views/settings/trucker-grouping/index.vue"),
  },
  {
    path: "/settings/permissions",
    name: "settings-permissions",
    meta: { title: "Permissions", authRequired: true, permission: "view:permissions" },
    component: () => import("../views/settings/permissions/index.vue"),
  },
  {
    path: "/settings/menus",
    name: "settings-menus",
    meta: { title: "Menus", authRequired: true, permission: "view:menus" },
    component: () => import("../views/settings/menus/index.vue"),
  },
  {
    path: "/settings/mobile-menus",
    name: "settings-mobile-menus",
    meta: { title: "Mobile Menus", authRequired: true, permission: "view:mobile-menus" },
    component: () => import("../views/settings/mobile-menus/index.vue"),
  },
  {
    path: "/settings/dashboard-widgets",
    name: "settings-dashboard-widgets",
    meta: { title: "Dashboard Widgets", authRequired: true, permission: "view:dashboard-widgets" },
    component: () => import("../views/settings/dashboard-widgets/index.vue"),
  },
  {
    path: "/settings/app-versions",
    name: "settings-app-versions",
    meta: { title: "App Versions", authRequired: true, permission: "view:settings-app-versions" },
    component: () => import("../views/settings/app-versions/index.vue"),
  },
  {
    path: "/dashboard/crypto",
    name: "dashboard-crypto",
    meta: {
      title: "Crypto",
      authRequired: true,
    },
    component: () => import("../views/dashboard/crypto/index"),
  },
  {
    path: "/dashboard/projects",
    name: "dashboard-projects",
    meta: {
      title: "Projects", authRequired: true,
    },
    component: () => import("../views/dashboard/projects/index"),
  },
  {
    path: "/dashboard/crm",
    name: "dashboard-crm",
    meta: {
      title: "CRM", authRequired: true,
    },
    component: () => import("../views/dashboard/crm/index"),
  },
  {
    path: "/dashboard/analytics",
    name: "dashboard-analytics",
    meta: {
      title: "Analytics", authRequired: true,
    },
    component: () => import("../views/dashboard/analytics/index"),
  },
  {
    path: "/dashboard/nft",
    name: "dashboard-nft",
    meta: {
      title: "NFT Dashboard", authRequired: true,
    },
    component: () => import("../views/dashboard/nft/index"),
  },
  {
    path: "/dashboard/job",
    name: "dashboard-job",
    meta: {
      title: "Job Dashboard", authRequired: true,
    },
    component: () => import("../views/dashboard/job/index"),
  },
  {
    path: "/logout",
    name: "logout",
    meta: {
      title: "Logout", authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        localStorage.clear();
        sessionStorage.clear();
        next();
      },
    },
    component: () => import("../views/auth/logout/basic")
  },
  {
    path: "/calendar",
    name: "calendar",
    meta: { title: "Calendar", authRequired: true },
    component: () => import("../views/calendar/index"),
  },
  {
    path: "/chat",
    name: "chat",
    meta: { title: "Chat", authRequired: true },
    component: () => import("../views/apps/chat"),
  },
  {
    path: "/apps-file-manager",
    name: "file manager",
    meta: { title: "File Manager", authRequired: true },
    component: () => import("../views/apps/filemanager"),
  },
  {
    path: "/apps-todo",
    name: "To Do List",
    meta: { title: "To Do List", authRequired: true },
    component: () => import("../views/apps/todo"),
  },
  {
    path: "/mailbox",
    name: "mailbox",
    meta: { title: "Mailbox", authRequired: true },
    component: () => import("../views/apps/email/mailbox"),
  },
  {
    path: "/email/email-basic",
    name: "email-basic",
    meta: { title: "Basic Action", authRequired: true },
    component: () => import("../views/apps/email/email-basic"),
  },
  {
    path: "/email/email-ecommerce",
    name: "email-ecommerce",
    meta: { title: "Ecommerce Action", authRequired: true },
    component: () => import("../views/apps/email/email-ecommerce"),
  },
  {
    path: "/apps/nft-auction",
    name: "auction",
    meta: { title: "Live Auction", authRequired: true },
    component: () => import("../views/apps/nft/nft-auction"),
  },
  {
    path: "/apps/nft-collection",
    name: "collection",
    meta: { title: "Collactions", authRequired: true },
    component: () => import("../views/apps/nft/nft-collection"),
  },
  {
    path: "/apps/nft-create",
    name: "create",
    meta: { title: "Create", authRequired: true },
    component: () => import("../views/apps/nft/nft-create"),
  },
  {
    path: "/apps/nft-creators",
    name: "creators",
    meta: { title: "Creators", authRequired: true },
    component: () => import("../views/apps/nft/nft-creators"),
  },
  {
    path: "/apps/nft-explore",
    name: "explore",
    meta: { title: "Explore Now", authRequired: true },
    component: () => import("../views/apps/nft/nft-explore"),
  },
  {
    path: "/apps/nft-item-detail",
    name: "item-detail",
    meta: { title: "Item Detail", authRequired: true },
    component: () => import("../views/apps/nft/nft-item-detail"),
  },
  {
    path: "/apps/nft-marketplace",
    name: "marketplace",
    meta: { title: "Marketplace", authRequired: true },
    component: () => import("../views/apps/nft/nft-marketplace"),
  },
  {
    path: "/apps/nft-ranking",
    name: "ranking",
    meta: { title: "Ranking", authRequired: true },
    component: () => import("../views/apps/nft/nft-ranking"),
  },
  {
    path: "/apps/nft-wallet",
    name: "nft-wallet",
    meta: { title: "Wallet", authRequired: true },
    component: () => import("../views/apps/nft/nft-wallet"),
  },
  {
    path: "/apps/projects-list",
    name: "projects-list",
    meta: { title: "Projects List", authRequired: true },
    component: () => import("../views/apps/projects/list"),
  },
  {
    path: "/apps/projects-overview",
    name: "projects Overview",
    meta: { title: "Projects Overview", authRequired: true },
    component: () => import("../views/apps/projects/overview"),
  },
  {
    path: "/apps/projects-create",
    name: "projects-create",
    meta: { title: "Projects Create", authRequired: true },
    component: () => import("../views/apps/projects/create"),
  },
  {
    path: "/apps/tasks-details",
    name: "tasks-details",
    meta: { title: "Tasks Details", authRequired: true },
    component: () => import("../views/apps/tasks/details"),
  },
  {
    path: "/apps/tasks-kanban",
    name: "tasks-kanban",
    meta: { title: "Tasks Kanban", authRequired: true },
    component: () => import("../views/apps/tasks/kanban"),
  },
  {
    path: "/apps/tasks-list-view",
    name: "tasks-list-view",
    meta: { title: "Taks List", authRequired: true },
    component: () => import("../views/apps/tasks/list-view"),
  },
  {
    path: "/apps/tickets-details",
    name: "tickets-details",
    meta: { title: "Ticket Details", authRequired: true },
    component: () => import("../views/tickets/details"),
  },
  {
    path: "/apps/tickets-list",
    name: "tickets-list",
    meta: { title: "Tickets List", authRequired: true },
    component: () => import("../views/tickets/list"),
  },
  {
    path: "/apps/crm-contacts",
    name: "crm-contacts",
    meta: { title: "CRM Contacts", authRequired: true },
    component: () => import("../views/apps/crm/contacts"),
  },
  {
    path: "/apps/crm-companies",
    name: "crm-companies",
    meta: { title: "CRM companies", authRequired: true },
    component: () => import("../views/apps/crm/companies"),
  },
  {
    path: "/apps/crm-deals",
    name: "crm-deals",
    meta: { title: "CRM Deals", authRequired: true },
    component: () => import("../views/apps/crm/deals"),
  },
  {
    path: "/apps/crm-leads",
    name: "crm-leads",
    meta: { title: "CRM Leads", authRequired: true },
    component: () => import("../views/apps/crm/leads"),
  },
  {
    path: "/ecommerce/customers",
    name: "customers",
    meta: { title: "Customers", authRequired: true },
    component: () => import("../views/apps/ecommerce/customers"),
  },
  {
    path: "/ecommerce/products",
    name: "products",
    meta: { title: "Products", authRequired: true },
    component: () => import("../views/apps/ecommerce/products"),
  },
  {
    path: "/ecommerce/product-details",
    name: "product-detail",
    meta: { title: "Product Details", authRequired: true },
    component: () => import("../views/apps/ecommerce/product-details"),
  },
  {
    path: "/ecommerce/orders",
    name: "orders",
    meta: { title: "Orders", authRequired: true },
    component: () => import("../views/apps/ecommerce/orders"),
  },
  {
    path: "/ecommerce/order-details",
    name: "order-details",
    meta: { title: "Order Details", authRequired: true },
    component: () => import("../views/apps/ecommerce/order-details"),
  },
  {
    path: "/ecommerce/add-product",
    name: "add-product",
    meta: { title: "Create Product", authRequired: true },
    component: () => import("../views/apps/ecommerce/add-product"),
  },
  {
    path: "/ecommerce/shopping-cart",
    name: "shopping cart",
    meta: { title: "Shopping Cart", authRequired: true },
    component: () => import("../views/apps/ecommerce/shopping-cart"),
  },
  {
    path: "/ecommerce/checkout",
    name: "checkout",
    meta: { title: "Check Out", authRequired: true },
    component: () => import("../views/apps/ecommerce/checkout"),
  },
  {
    path: "/ecommerce/sellers",
    name: "sellers",
    meta: { title: "Sellers", authRequired: true },
    component: () => import("../views/apps/ecommerce/sellers"),
  },
  {
    path: "/ecommerce/seller-details",
    name: "seller-details",
    meta: { title: "Seller Details", authRequired: true },
    component: () => import("../views/apps/ecommerce/seller-details"),
  },
  {
    path: "/crypto/buy-sell",
    name: "buy/sell",
    meta: { title: "Buy & Sell", authRequired: true },
    component: () => import("../views/apps/crypto/buy-sell"),
  },
  {
    path: "/crypto/kyc",
    name: "kyc",
    meta: { title: "KYC Application", authRequired: true },
    component: () => import("../views/apps/crypto/kyc"),
  },
  {
    path: "/crypto/ico",
    name: "ico",
    meta: { title: "ICO List", authRequired: true },
    component: () => import("../views/apps/crypto/ico"),
  },
  {
    path: "/crypto/orders",
    name: "crypto-orders",
    meta: { title: "Orders", authRequired: true },
    component: () => import("../views/apps/crypto/orders"),
  },
  {
    path: "/crypto/wallet",
    name: "wallet",
    meta: { title: "My Wallet", authRequired: true },
    component: () => import("../views/apps/crypto/wallet"),
  },
  {
    path: "/crypto/transactions",
    name: "transactions",
    meta: { title: "Transactions", authRequired: true },
    component: () => import("../views/apps/crypto/transactions"),
  },
  {
    path: "/invoices/detail/:id?",
    name: "invoice-detail",
    meta: { title: "Invoice Details", authRequired: true },
    component: () => import("../views/apps/invoices/details"),
  },
  {
    path: "/invoices/list",
    name: "invoice-list",
    meta: { title: "Invoice List", authRequired: true },
    component: () => import("../views/apps/invoices/list"),
  },
  {
    path: "/invoices/create",
    name: "invoice-create",
    meta: { title: "Create Invoice", authRequired: true },
    component: () => import("../views/apps/invoices/create"),
  },
  {
    path: "/jobs/application",
    name: "job-application",
    meta: { title: "Job Application", authRequired: true },
    component: () => import("../views/apps/jobs/application"),
  },
  {
    path: "/jobs/candidate-grid",
    name: "job-candidate-grid",
    meta: { title: "Candidate Grid", authRequired: true },
    component: () => import("../views/apps/jobs/candidate-grid"),
  },
  {
    path: "/jobs/candidate-lists",
    name: "job-candidate-lists",
    meta: { title: "Candidate Lists", authRequired: true },
    component: () => import("../views/apps/jobs/candidate-lists"),
  },
  {
    path: "/jobs/categories",
    name: "job-categories",
    meta: { title: "Job Categories", authRequired: true },
    component: () => import("../views/apps/jobs/categories"),
  },
  {
    path: "/jobs/companies-list",
    name: "job-companies-list",
    meta: { title: "Companies List", authRequired: true },
    component: () => import("../views/apps/jobs/companies-list"),
  },
  {
    path: "/jobs/details",
    name: "job-details",
    meta: { title: "Job Details", authRequired: true },
    component: () => import("../views/apps/jobs/details"),
  },
  {
    path: "/jobs/grid-lists",
    name: "job-grid-lists",
    meta: { title: "Grid Lists", authRequired: true },
    component: () => import("../views/apps/jobs/grid-lists"),
  },
  {
    path: "/jobs/lists",
    name: "job-lists",
    meta: { title: "Job Lists", authRequired: true },
    component: () => import("../views/apps/jobs/lists"),
  },
  {
    path: "/jobs/new",
    name: "job-new",
    meta: { title: "New Job", authRequired: true },
    component: () => import("../views/apps/jobs/new"),
  },
  {
    path: "/jobs/statistics",
    name: "job-statistics",
    meta: { title: "Job Statistics", authRequired: true },
    component: () => import("../views/apps/jobs/statistics"),
  },
  {
    path: "/apps-api-key",
    name: "API Key",
    meta: { title: "API Key", authRequired: true },
    component: () => import("../views/apps/apikey"),
  },

  {
    path: "/ui/alerts",
    name: "Alerts",
    meta: {
      title: "Alerts", authRequired: true,
    },
    component: () => import("../views/ui/alerts"),
  },
  {
    path: "/ui/buttons",
    name: "Buttons",
    meta: {
      title: "Buttons", authRequired: true,
    },
    component: () => import("../views/ui/buttons"),
  },
  {
    path: "/ui/cards",
    name: "Cards",
    meta: { title: "Cards", authRequired: true },
    component: () => import("../views/ui/cards"),
  },
  {
    path: "/ui/carousel",
    name: "Carousel",
    meta: { title: "Carousel", authRequired: true },
    component: () => import("../views/ui/carousel"),
  },
  {
    path: "/ui/dropdowns",
    name: "Dropdowns",
    meta: { title: "Dropdowns", authRequired: true },
    component: () => import("../views/ui/dropdowns"),
  },
  {
    path: "/ui/grid",
    name: "Grid",
    meta: { title: "Grid", authRequired: true },
    component: () => import("../views/ui/grid"),
  },
  {
    path: "/ui/images",
    name: "Images",
    meta: { title: "Images", authRequired: true },
    component: () => import("../views/ui/images"),
  },
  {
    path: "/ui/modals",
    name: "Modals",
    meta: { title: "Modals", authRequired: true },
    component: () => import("../views/ui/modals"),
  },
  {
    path: "/ui/offcanvas",
    name: "offcanvas",
    meta: { title: "Offcanvas", authRequired: true },
    component: () => import("../views/ui/offcanvas"),
  },
  {
    path: "/ui/progress",
    name: "Progress",
    meta: { title: "Progress", authRequired: true },
    component: () => import("../views/ui/progress"),
  },
  {
    path: "/ui/placeholders",
    name: "Placeholders",
    meta: { title: "Placeholders", authRequired: true },
    component: () => import("../views/ui/placeholders"),
  },
  {
    path: "/ui/accordions",
    name: "accordions",
    meta: { title: "Accordions", authRequired: true },
    component: () => import("../views/ui/accordions"),
  },
  {
    path: "/ui/tabs",
    name: "tabs",
    meta: { title: "Tabs", authRequired: true },
    component: () => import("../views/ui/tabs"),
  },
  {
    path: "/ui/typography",
    name: "Typography",
    meta: { title: "Typography", authRequired: true },
    component: () => import("../views/ui/typography"),
  },
  {
    path: "/ui/embed-video",
    name: "embed-video",
    meta: { title: "Embed Video", authRequired: true },
    component: () => import("../views/ui/embed-video"),
  },
  {
    path: "/ui/ribbons",
    name: "ribbons",
    meta: { title: "Ribbons", authRequired: true },
    component: () => import("../views/ui/ribbons"),
  },
  {
    path: "/ui/lists",
    name: "lists",
    meta: { title: "Lists", authRequired: true },
    component: () => import("../views/ui/lists"),
  },
  {
    path: "/ui/utilities",
    name: "utilities",
    meta: { title: "Utilities", authRequired: true },
    component: () => import("../views/ui/utilities"),
  },
  {
    path: "/ui/notifications",
    name: "notifications",
    meta: { title: "Notifications", authRequired: true },
    component: () => import("../views/ui/notifications"),
  },
  {
    path: "/ui/general",
    name: "General",
    meta: { title: "General", authRequired: true },
    component: () => import("../views/ui/general"),
  },
  {
    path: "/ui/colors",
    name: "Colors",
    meta: { title: "Colors", authRequired: true },
    component: () => import("../views/ui/colors"),
  },
  {
    path: "/ui/badges",
    name: "badges",
    meta: { title: "Badges", authRequired: true },
    component: () => import("../views/ui/badges"),
  },
  {
    path: "/ui/media",
    name: "media",
    meta: { title: "Media", authRequired: true },
    component: () => import("../views/ui/media"),
  },
  {
    path: "/widgets",
    name: "widgets",
    meta: { title: "Widgets", authRequired: true },
    component: () => import("../views/widgets/index"),
  },
  {
    path: "/icons/boxicons",
    name: "boxicons-icon",
    meta: { title: "Boxicons", authRequired: true },
    component: () => import("../views/icons/boxicons"),
  },
  {
    path: "/icons/materialdesign",
    name: "Material Design",
    meta: { title: "Material Design", authRequired: true },
    component: () => import("../views/icons/materialdesign"),
  },
  {
    path: "/icons/feather",
    name: "feather",
    meta: { title: "Feather", authRequired: true },
    component: () => import("../views/icons/feather"),
  },
  {
    path: "/icons/lineawesome",
    name: "lineawesome",
    meta: { title: "Line Awesome", authRequired: true },
    component: () => import("../views/icons/lineawesome"),
  },
  {
    path: "/icons/remix",
    name: "remix",
    meta: { title: "Remix", authRequired: true },
    component: () => import("../views/icons/remix"),
  },
  {
    path: "/icons/crypto",
    name: "crypto",
    meta: { title: "Crypto", authRequired: true },
    component: () => import("../views/icons/crypto"),
  },
  {
    path: "/tables/basic",
    name: "basic-table",
    meta: { title: "Basic Table", authRequired: true },
    component: () => import("../views/tables/basic"),
  },
  {
    path: "/tables/gridjs",
    name: "gridjs",
    meta: { title: "Grid JS", authRequired: true },
    component: () => import("../views/tables/grid/index"),
  },
  {
    path: "/form/advanced",
    name: "form-advanced",
    meta: { title: "Form Advance", authRequired: true },
    component: () => import("../views/forms/advanced"),
  },
  {
    path: "/form/elements",
    name: "form-elements",
    meta: { title: "Form Elements", authRequired: true },
    component: () => import("../views/forms/elements"),
  },
  {
    path: "/form/layouts",
    name: "Form Layouts",
    meta: { title: "Form Layouts", authRequired: true },
    component: () => import("../views/forms/layouts"),
  },
  {
    path: "/form/editors",
    name: "Form Editors",
    meta: { title: "Form Editors", authRequired: true },
    component: () => import("../views/forms/editors"),
  },
  {
    path: "/form/file-uploads",
    name: "File Uploads",
    meta: { title: "File Uploads", authRequired: true },
    component: () => import("../views/forms/file-uploads"),
  },
  {
    path: "/form/validation",
    name: "Form Validation",
    meta: { title: "Form Validation", authRequired: true },
    component: () => import("../views/forms/validation"),
  },
  {
    path: "/form/wizard",
    name: "Form Wizard",
    meta: { title: "Form Wizard", authRequired: true },
    component: () => import("../views/forms/wizard"),
  },
  {
    path: "/form/masks",
    name: "form-mask",
    meta: { title: "Form Mask", authRequired: true },
    component: () => import("../views/forms/masks"),
  },
  {
    path: "/form/pickers",
    name: "form-pickers",
    meta: { title: "Form Picker", authRequired: true },
    component: () => import("../views/forms/pickers"),
  },
  {
    path: "/form/range-sliders",
    name: "form-range-slider",
    meta: { title: "Form Range Slider", authRequired: true },
    component: () => import("../views/forms/range-sliders"),
  },
  {
    path: "/form/select",
    name: "form-select",
    meta: { title: "Form Select", authRequired: true },
    component: () => import("../views/forms/select"),
  },
  {
    path: "/form/checkboxs-radios",
    name: "form-checkboxs-radio",
    meta: { title: "Checkboxs & Radios", authRequired: true },
    component: () => import("../views/forms/checkboxs-radios"),
  },
  {
    path: "/landing",
    name: "landing",
    meta: { title: "Landing", authRequired: true },
    component: () => import("../views/landing/index"),
  },
  {
    path: "/nft-landing",
    name: "nft-landing",
    meta: { title: "Landing", authRequired: true },
    component: () => import("../views/landing/nft-landing"),
  },
  {
    path: "/job-landing",
    name: "job-landing",
    meta: { title: "Job Landing", authRequired: true },
    component: () => import("../views/landing/job-landing"),
  },
  {
    path: "/pages/starter",
    name: "starter",
    meta: { title: "Starter", authRequired: true },
    component: () => import("../views/pages/starter"),
  },
  {
    path: "/pages/profile",
    name: "profile",
    meta: { title: "Profile", authRequired: true },
    component: () => import("../views/pages/profile/simple"),
  },
  {
    path: "/pages/profile-setting",
    name: "profile-setting",
    meta: { title: "Setting", authRequired: true },
    component: () => import("../views/pages/profile/setting"),
  },
  {
    path: "/pages/maintenance",
    name: "maintenance",
    meta: { title: "Maintanance", authRequired: true },
    component: () => import("../views/pages/maintenance"),
  },
  {
    path: "/pages/coming-soon",
    name: "coming-soon",
    meta: { title: "Comming Soon", authRequired: true },
    component: () => import("../views/pages/coming-soon"),
  },
  {
    path: "/pages/timeline",
    name: "timeline",
    meta: { title: "Timeline", authRequired: true },
    component: () => import("../views/pages/timeline"),
  },
  {
    path: "/pages/faqs",
    name: "FAQs",
    meta: { title: "FAQs", authRequired: true },
    component: () => import("../views/pages/faqs"),
  },
  {
    path: "/pages/pricing",
    name: "pricing",
    meta: { title: "Pricing", authRequired: true },
    component: () => import("../views/pages/pricing"),
  },
  {
    path: "/pages/team",
    name: "team",
    meta: { title: "Team", authRequired: true },
    component: () => import("../views/pages/team"),
  },
  {
    path: "/pages/search-results",
    name: "search-results",
    meta: { title: "Search Results", authRequired: true },
    component: () => import("../views/pages/search-results"),
  },
  {
    path: "/pages/sitemap",
    name: "sitemap",
    meta: { title: "Sitemap", authRequired: true },
    component: () => import("../views/pages/sitemap"),
  },
  {
    path: "/pages/privacy-policy",
    name: "privacy-policy",
    meta: { title: "Privacy Policy", authRequired: true },
    component: () => import("../views/pages/privacy-policy"),
  },
  {
    path: "/pages/term-conditions",
    name: "term-conditions",
    meta: { title: "Term Conditions", authRequired: true },
    component: () => import("../views/pages/term-conditions"),
  },
  {
    path: "/charts/chartjs",
    name: "chartjs-chart",
    meta: { title: "Chartjs", authRequired: true },
    component: () => import("../views/charts/chartjs/index"),
  },
  {
    path: "/charts/echart",
    name: "echart",
    meta: { title: "Echarts", authRequired: true },
    component: () => import("../views/charts/echart/index"),
  },
  {
    path: '/charts/apex-line',
    name: 'line',
    meta: {
      title: "Line Charts", authRequired: true,
    },
    component: () => import('../views/charts/apex/line/index')
  },
  {
    path: '/charts/apex-area',
    name: 'area-chart',
    meta: {
      title: "Area Charts", authRequired: true,
    },
    component: () => import('../views/charts/apex/area/index')
  },
  {
    path: '/charts/apex-bar',
    name: 'bar-chart',
    meta: {
      title: "Bar Charts", authRequired: true,
    },
    component: () => import('../views/charts/apex/bar/index')
  },
  {
    path: '/charts/apex-column',
    name: 'column-chart',
    meta: {
      title: "Column Charts", authRequired: true,
    },
    component: () => import('../views/charts/apex/column/index')
  },

  {
    path: '/charts/apex-mixed',
    name: 'mixed-chart',
    meta: {
      title: "Mixed Charts", authRequired: true,
    },
    component: () => import('../views/charts/apex/mixed/index')
  },
  {
    path: '/charts/apex-candlestick',
    name: 'candlestick',
    meta: {
      title: "Candlestick", authRequired: true,
    },
    component: () => import('../views/charts/apex/candlestick/index')
  },
  {
    path: '/charts/apex-boxplot',
    name: 'boxplot',
    meta: {
      title: "Boxplot", authRequired: true,
    },
    component: () => import('../views/charts/apex/boxplot/index')
  },
  {
    path: '/charts/apex-bubble',
    name: 'bubble',
    meta: {
      title: "Bubble Chart", authRequired: true,
    },
    component: () => import('../views/charts/apex/bubble/index')
  },
  {
    path: '/charts/apex-scatter',
    name: 'scatter',
    meta: {
      title: "Scatter", authRequired: true,
    },
    component: () => import('../views/charts/apex/scatter/index')
  },
  {
    path: '/charts/apex-heatmap',
    name: 'heatmap',
    meta: {
      title: "Heatmap", authRequired: true,
    },
    component: () => import('../views/charts/apex/heatmap/index')
  },
  {
    path: '/charts/apex-treemap',
    name: 'treemap',
    meta: {
      title: "Treemap", authRequired: true,
    },
    component: () => import('../views/charts/apex/treemap/index')
  },
  {
    path: '/charts/apex-pie',
    name: 'pie',
    meta: {
      title: "Apex Pie", authRequired: true,
    },
    component: () => import('../views/charts/apex/pie/index')
  },
  {
    path: '/charts/apex-radialbar',
    name: 'radialbar',
    meta: {
      title: "Apex Radialbar", authRequired: true,
    },
    component: () => import('../views/charts/apex/radiabar/index')
  },
  {
    path: '/charts/apex-radar',
    name: 'radar',
    meta: {
      title: "Apex Radar", authRequired: true,
    },
    component: () => import('../views/charts/apex/radar/index')
  },
  {
    path: '/charts/apex-polararea',
    name: 'polararea',
    meta: {
      title: "Polararea", authRequired: true,
    },
    component: () => import('../views/charts/apex/polararea/index')
  },
  {
    path: '/advance-ui/animation',
    name: 'animation',
    meta: {
      title: "Animation", authRequired: true,
    },
    component: () => import('../views/advance-ui/animation')
  },
  {
    path: '/advance-ui/highlight',
    name: 'highlight',
    meta: {
      title: "Highlight", authRequired: true,
    },
    component: () => import('../views/advance-ui/highlight')
  },
  {
    path: '/advance-ui/scrollbar',
    name: 'scrollbar',
    meta: {
      title: "Scrollbar", authRequired: true,
    },
    component: () => import('../views/advance-ui/scrollbar')
  },
  {
    path: '/advance-ui/scrollspy',
    name: 'scrollspy',
    meta: {
      title: "Scrollspy", authRequired: true,
    },
    component: () => import('../views/advance-ui/scrollspy')
  },
  {
    path: '/advance-ui/sweetalerts',
    name: 'sweetalerts',
    meta: {
      title: "Sweet Alerts", authRequired: true,
    },
    component: () => import('../views/advance-ui/sweetalerts')
  },
  {
    path: '/advance-ui/swiper',
    name: 'Swiper Slider',
    meta: {
      title: "Swiper", authRequired: true,
    },
    component: () => import('../views/advance-ui/swiper')
  },
  {
    path: '/auth/signin-basic',
    name: 'signin-basic',
    meta: {
      title: "Signin Basic", authRequired: true,
    },
    component: () => import('../views/auth/signin/basic')
  },
  {
    path: '/auth/signin-cover',
    name: 'signin-cover',
    meta: {
      title: "Signin Cover", authRequired: true,
    },
    component: () => import('../views/auth/signin/cover')
  },
  {
    path: '/auth/signup-basic',
    name: 'signup-basic',
    meta: {
      title: "Signup Basic", authRequired: true,
    },
    component: () => import('../views/auth/signup/basic')
  },
  {
    path: '/auth/signup-cover',
    name: 'signup-cover',
    meta: {
      title: "Signup Cover", authRequired: true,
    },
    component: () => import('../views/auth/signup/cover')
  },
  {
    path: '/auth/reset-pwd-basic',
    name: 'reset-pwd-basic',
    meta: {
      title: "Reset Password", authRequired: true,
    },
    component: () => import('../views/auth/reset/basic')
  },
  {
    path: '/auth/reset-pwd-cover',
    name: 'reset-pwd-cover',
    meta: {
      title: "Reset Password", authRequired: true,
    },
    component: () => import('../views/auth/reset/cover')
  },
  {
    path: '/auth/create-pwd-basic',
    name: 'create-pwd-basic',
    meta: {
      title: "create Password", authRequired: true,
    },
    component: () => import('../views/auth/create/basic')
  },
  {
    path: '/auth/create-pwd-cover',
    name: 'create-pwd-cover',
    meta: {
      title: "create Password", authRequired: true,
    },
    component: () => import('../views/auth/create/cover')
  },
  {
    path: '/auth/lockscreen-basic',
    name: 'lock-screen-basic',
    meta: {
      title: "Lock Screen", authRequired: true,
    },
    component: () => import('../views/auth/lockscreen/basic')
  },
  {
    path: '/auth/lockscreen-cover',
    name: 'lock-screen-cover',
    meta: {
      title: "Lock Screen", authRequired: true,
    },
    component: () => import('../views/auth/lockscreen/cover')
  },
  {
    path: '/auth/twostep-basic',
    name: 'twostep-basic',
    meta: {
      title: "Two Step Auth", authRequired: true,
    },
    component: () => import('../views/auth/twostep/basic')
  }, {
    path: '/auth/twostep-cover',
    name: 'twostep-cover',
    meta: {
      title: "Two Step Auth", authRequired: true,
    },
    component: () => import('../views/auth/twostep/cover')
  },
  {
    path: '/access-denied',
    name: 'access-denied',
    meta: { title: "Access Denied", authRequired: true },
    component: () => import('../views/auth/errors/access-denied'),
  },
  {
    path: '/auth/404',
    name: '404',
    meta: {
      title: "Error 404", authRequired: true,
    },
    component: () => import('../views/auth/errors/404')
  },
  {
    path: '/auth/500',
    name: '500',
    meta: {
      title: "Error 500", authRequired: true,
    },
    component: () => import('../views/auth/errors/500')
  },
  {
    path: '/auth/404-basic',
    name: '404-basic',
    meta: {
      title: "Error 404", authRequired: true,
    },
    component: () => import('../views/auth/errors/404-basic')
  },
  {
    path: '/auth/404-cover',
    name: '404-cover',
    meta: {
      title: "Error 404", authRequired: true,
    },
    component: () => import('../views/auth/errors/404-cover')
  },
  {
    path: '/auth/ofline',
    name: 'ofline',
    meta: {
      title: "Offline", authRequired: true,
    },
    component: () => import('../views/auth/errors/ofline')
  },
  {
    path: '/auth/logout-basic',
    name: 'logout-basic',
    meta: {
      title: "Logout", authRequired: true,
    },
    component: () => import('../views/auth/logout/basic')
  },
  {
    path: '/auth/logout-cover',
    name: 'logout-cover',
    meta: {
      title: "Logout", authRequired: true,
    },
    component: () => import('../views/auth/logout/cover')
  },
  {
    path: '/auth/success-msg-basic',
    name: 'success-msg-basic',
    meta: {
      title: "Success Message", authRequired: true,
    },
    component: () => import('../views/auth/success-msg/basic')
  },
  {
    path: '/auth/success-msg-cover',
    name: 'success-msg-cover',
    meta: {
      title: "Success Message", authRequired: true,
    },
    component: () => import('../views/auth/success-msg/cover')
  },
  {
    path: "/maps/google",
    name: "Google Maps",
    meta: {
      title: "Google Maps", authRequired: true,
    },
    component: () => import("../views/maps/google"),
  },
  {
    path: "/maps/leaflet",
    name: "Leaflet Maps",
    meta: { title: "Leaflet Maps", authRequired: true },
    component: () => import("../views/maps/leaflet/index"),
  },
];